
import dayjs from "dayjs"
import Article from "./Article"
import Banner from "./Banner"
import AppButton from "./AppButton"
import projectUrlResolverMixin from "../mixins/projectUrlResolverMixin"

const removeTrailingSlash = str => str && str.replace(/\/$/, "")

export default {
  components: {
    Article,
    Banner,
    AppButton
  },
  mixins: [projectUrlResolverMixin],
  props: {
    heading: {
      type: Object,
      default: () => {}
    },
    pagesToShowOn: {
      type: Array,
      default: () => []
    },
    expiryDate: {
      type: String,
      default: null
    },
    dropdownContent: {
      type: Object,
      default: () => {}
    },
    enabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: ""
    },
    bannerImage: {
      type: Object,
      default: null,
      required: false
    },
    actionButton: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  computed: {
    showBanner() {
      return this.enabled && !this.expired && this.currentPageEnablesBanner
    },
    expired() {
      if (!this.expiryDate) return false

      const now = dayjs()
      const expiryDate = dayjs(this.expiryDate)

      if (!expiryDate.isValid()) return true

      return expiryDate.endOf("day").isBefore(now)
    },
    currentPageEnablesBanner() {
      if (this.pagesToShowOn.length === 0) {
        return true
      }
      // $route is not available in web component context
      let currentUrl = this.$route ? this.$route.path : location.pathname
      currentUrl =
        currentUrl === "/" ? currentUrl : removeTrailingSlash(currentUrl)

      return this.pagesToShowOn.some(({ link, component: linkType }) => {
        if (!link) return

        const resolvedPath = this.resolveLink({
          link,
          linkType
        })
        return resolvedPath === currentUrl
      })
    }
  }
}
